import React from "react";
import { useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { LogIn, Zap } from "lucide-react";
import { API } from "../lib/api";

export default function Login() {
  const loc = useLocation();
  // Error can arrive via router state or as a ?error= query param from the OAuth callback redirect.
  const params = new URLSearchParams(loc.search);
  const error = loc.state?.error || params.get("error");

  const handleLogin = () => {
    // Self-hosted Google OAuth: the backend drives the whole authorization-code flow.
    window.location.href = `${API}/auth/login`;
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div className="relative w-full max-w-md bg-white border border-zinc-200 p-10" data-testid="login-card">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-zinc-900 flex items-center justify-center">
            <Zap className="w-4 h-4 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-display font-bold tracking-tight uppercase">MetricFlow</span>
        </div>

        <div className="data-label mb-2">Sign in</div>
        <h1 className="font-display text-3xl tracking-tighter font-bold uppercase mb-2">
          Access the control room
        </h1>
        <p className="text-sm text-zinc-600 mb-8 max-w-sm">
          MetricFlow is restricted to authorised users. Sign in with your Google account
          to continue.
        </p>

        {error && (
          <div className="mb-5 p-3 bg-red-50 border border-red-200 text-red-700 text-xs font-mono">
            {error}
          </div>
        )}

        <Button
          data-testid="google-login-btn"
          onClick={handleLogin}
          className="w-full rounded-none bg-zinc-900 hover:bg-zinc-800 text-white font-mono uppercase tracking-wider text-xs h-11"
        >
          <LogIn className="w-4 h-4 mr-2" />
          Continue with Google
        </Button>

        <div className="mt-10 pt-6 border-t border-zinc-200">
          <div className="data-label mb-2">What this unlocks</div>
          <ul className="text-xs text-zinc-600 font-mono space-y-1">
            <li>· Live ThoughtMetric CPA data</li>
            <li>· Meta + Google Ads budget pushes</li>
            <li>· Scheduled rules with Slack alerts</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
